import { c as _c } from "react/compiler-runtime";
import { useRefreshSeatUsage } from "@components/table/members/assign-seats/use-refresh-seat-usage";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useToast, Text, NO_TRANSLATE_CLASS } from "@flat-ui";
import { setMemberPermissionsInCompany, updateMemberRoleInWorkspace } from "@store/members/members-slice-thunk";
import { releaseAssignedXgSeat } from "@store/sdb-company/sdb-company-slice";
import { useAppDispatch } from "@store/store-helper";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getPrettyName } from "@utils/user-utils";
/**
 * Returns how to take the Sphere XG seat of a member away, which is the `activeSeat` permission of
 * the member. An admin is given a workspace role that needs no seat first.
 */
export function useRemoveXgSeat() {
  const $ = _c(7);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const refreshSeatUsage = useRefreshSeatUsage();
  let t0;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== handleErrorWithToast || $[3] !== openToast || $[4] !== refreshSeatUsage || $[5] !== trackEvent) {
    const removeXgSeat = async function removeXgSeat(member, newWorkspaceRole) {
      trackEvent({
        name: WorkspaceEvents.unassignXgSeat,
        props: {
          location: "workspace-members-table",
          newWorkspaceRole: newWorkspaceRole ?? "unchanged"
        }
      });
      if (newWorkspaceRole && !(await changeWorkspaceRole(member, newWorkspaceRole))) {
        return false;
      }
      ;
      try {
        await dispatch(setMemberPermissionsInCompany({
          companyId,
          userIdentity: member.identity,
          permissions: [{
            name: "activeSeat",
            allowed: false
          }]
        })).unwrap();
        dispatch(releaseAssignedXgSeat());
        refreshSeatUsage();
        openToast({
          title: "Sphere XG seat removed",
          message: <>Successfully removed the seat for{" "}<Text variant="bodyM" sx={{
              fontWeight: "bold"
            }} className={NO_TRANSLATE_CLASS}>{getPrettyName(member)}</Text></>
        });
        return true;
      } catch (t1) {
        const error = t1;
        handleErrorWithToast({
          id: `unassignXgSeat-${Date.now().toString()}`,
          title: "Cannot remove the Sphere XG seat",
          error
        });
        return false;
      }
    };
    async function changeWorkspaceRole(member_0, role) {
      try {
        await dispatch(updateMemberRoleInWorkspace({
          companyId,
          role,
          identity: member_0.identity
        })).unwrap();
        return true;
      } catch {
        return false;
      }
    }
    t0 = {
      removeXgSeat
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = handleErrorWithToast;
    $[3] = openToast;
    $[4] = refreshSeatUsage;
    $[5] = trackEvent;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}